import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fetchAuthSession, signInWithRedirect } from '@aws-amplify/auth';
import { LoggerService } from '@sko/ng-logging';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.sass',
    standalone: false
})
export class SignInComponent {

  private authenticatingSignal = signal<boolean>(true);

  authenticating = this.authenticatingSignal.asReadonly();

  private errorSignal = signal<string | undefined>(undefined);

  error = this.errorSignal.asReadonly();

  constructor(
    private activated: ActivatedRoute,
    private logger: LoggerService,
    private router: Router,
  ) {

    fetchAuthSession({ })
    .then((session) => {

      this.logger.info({ session }, 'SignInComponent');

      if (session.tokens?.idToken) {

        this.router.navigateByUrl('/')

      } else if (this.activated.snapshot.queryParams['error_description']) {

        this.errorSignal.set(this.activated.snapshot.queryParams['error_description']);

      } else {

        this.signIn();

      }

    })
    .catch((e) => {

      logger.error(e);

      this.authenticatingSignal.set(false);

    });

  }

  signIn() {

    signInWithRedirect({
      provider: 'Google',
    })
    .then(() => {

      this.logger.info('afer signInWithRedirect');

      this.router.navigateByUrl('/');

    })
    .catch((e) => {

      this.logger.error(e);

      this.authenticatingSignal.set(false);
      
    });

  }

  tryAgain() {

    location.href = '/';

  }

}
